import type { FeatureModule } from '@store/features/types';

export const patientCoveragesFeature: FeatureModule = {
  id: 'patientCoverages',
  name: 'Patient Coverages',

  dependencies: [], // No dependencies on other features

  reducers: {},

  middleware: [],
  // Note: Do NOT add RTK Query API middleware - it's already registered globally via baseApi

  // No persistence needed - coverages are fetched from API
  persistence: {
    enabled: false,
  },

  // No sync needed - API-only feature
  sync: {
    enabled: false,
  },

  setup: _store => {
    // Feature initialization if needed
  },

  cleanup: _store => {
    // Feature cleanup if needed
  },
};
